<template>
  <div class="yandex-outage-notification">
    <div class="yandex-outage-notification__body">
      <h1 class="yandex-outage-notification__title">Уважаемые клиенты!</h1>
      <div class="yandex-outage-notification__text">
        <p>
          В связи со сбоями функционала Яндекс Директ, информация об актуальных балансах временно
          недоступна. Пополнение рекламных кабинетов работает.
        </p>
        <p>
          Мы со своей стороны находимся в постоянном контакте с представителями Яндекс. Как только
          появится более детальная информация и предполагаемые сроки полного восстановления работы
          рекламного кабинета Директ, мы оповестим наших клиентов.
        </p>
      </div>
      <div class="yandex-outage-notification__button">
        <button @click="handleAccept">{{ $t('button_props.accept') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import * as Cookies from 'js-cookie';
import moment from 'moment';

export default {
  name: 'YandexOutageNotification',
  beforeDestroy() {
    const showAgainDate = moment().add(1, 'days');
    Cookies.set(
      'yandexOutageNotificationModalStatusV2',
      JSON.stringify({
        showAgain: showAgainDate.toISOString(),
      }),
      { expires: 365 }
    );
  },
  methods: {
    handleAccept() {
      this.$store.dispatch('Dialog/closeDialog');
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.yandex-outage-notification {
  padding: 3rem 5rem;

  &__body {
    display: flex;
    flex-direction: column;
  }

  &__title {
    color: $basicBlack;
    text-align: center;
    font-family: 'Roboto';
    font-size: 3rem;
    font-style: normal;
    font-weight: 500;
    line-height: 4rem;
    margin-bottom: 2rem;
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    color: #333;
    font-family: 'Roboto';
    font-size: 1.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: 2.8rem;
    width: 100%;
    margin-bottom: 3rem;

    p {
      margin: 0;

      ::v-deep strong {
        font-weight: 700;
      }
    }
  }

  &__button {
    display: flex;

    button {
      padding: 1.6rem 8rem;
      background: #f96714;
      border: none;
      border-radius: 0.4rem;
      color: #fff;
      text-align: center;
      font-family: 'Roboto';
      font-size: 1.6rem;
      font-style: normal;
      font-weight: 700;
      line-height: 2.4rem;
      margin: auto;
      cursor: pointer;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: #e05a0d;
      }
    }
  }
}

@include below(576px) {
  .yandex-outage-notification {
    padding: 2rem;

    &__title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      margin-bottom: 1.6rem;
    }

    &__text {
      font-size: 1.6rem;
      line-height: 2.4rem;
      margin-bottom: 2rem;
    }

    &__button {
      button {
        padding: 1.4rem 6rem;
        font-size: 1.4rem;
      }
    }
  }
}
</style>
